import React, { useContext, useEffect } from "react";
import "./hero.css";
import { useState } from "react";
import {
  Button,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";

import { styled } from "@mui/material/styles";
import DoneIcon from "@mui/icons-material/Done";
import audi from "../../assets/images/hero/audi.png";
import ford from "../../assets/images/hero/ford.png";
import honda from "../../assets/images/hero/honda.png";
import hyundai from "../../assets/images/hero/hyundai.png";
import kia from "../../assets/images/hero/kia.png";
import mahindra from "../../assets/images/hero/mahindra.png";
import merc from "../../assets/images/hero/merc.png";
import mg from "../../assets/images/hero/mg.png";
import nissan from "../../assets/images/hero/nissan.png";
import skoda from "../../assets/images/hero/skoda.png";
import suzuki from "../../assets/images/hero/suzuki.png";
import tata from "../../assets/images/hero/tata.png";
import toyota from "../../assets/images/hero/toyota.png";
import volkswagen from "../../assets/images/hero/Volkswagen.png";
import volvo from "../../assets/images/hero/volvo.png";
import EngineIcon from "../../assets/images/hero/HeroRightImages/engineIcon.png";
import CarLoanIcon from "../../assets/images/hero/HeroRightImages/carLoanIcon.png";
import CarPaintIcon from "../../assets/images/hero/HeroRightImages/carPaintIcon.png";
import FairPriceIcon from "../../assets/images/hero/HeroRightImages/fairPriceIcon.png";
import ScannerIcon from "../../assets/images/hero/HeroRightImages/scannerIcon.png";
import ReactPlayer from "react-player";
import WarrantyImg from "../../assets/images/hero/HeroRightImages/warrantyImg.png";
import GuaranteeImg from "../../assets/images/hero/HeroRightImages/guarantee.png";
import EastIcon from "@mui/icons-material/East";

// import HeroImageNew from "./heroImaheNew.png";
import Slider from "react-slick";
// import HeroRightImg from "../../assets/images/hero/heroright.png";
import HeroRightImg from "../../assets/images/hero/HeroImg.png";
import FeaturedPlayListOutlinedIcon from "@mui/icons-material/FeaturedPlayListOutlined";
import { MyContext } from "../../context";
var settings = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 25000,
  slidesToShow: 5,
  slidesToScroll: 6,
  autoplaySpeed: 0,
  cssEase: "linear",
  autoplay: true,
  variableWidth: true,
  infiniteScroll: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const StyledTextField = styled(TextField)`
  & label {
    color: black;
  }
  & .MuiFormHelperText-root.Mui-error {
    padding: 0px;
    font-size: 12px;
  }
  & label.Mui-focused {
    color: black;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      // - The <fieldset> inside the Input-root
      border-color: #003cc4; // - Set the Input border
      border-width: 2px;
    }
    &:hover fieldset {
      border-color: #003cc4; // - Set the Input border when parent has :hover
      border-width: 2px;
    }
    &.Mui-focused fieldset {
      // - Set the Input border when parent is focused
      border-color: #003cc4;
      border-width: 2px;
    }
  }
`;

function Hero() {
  const { pageData, country, createLeadfromHero } = useContext(MyContext);
  const [successMessage, setSuccessMessage] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    phoneCode: pageData?.contactUsPage?.phoneCode,
    city: "",
  });
  const [validateName, setValidateName] = useState(false);
  const [validateCity, setValidateCity] = useState(false);
  const [validateNumber, setValidateNumber] = useState(false);
  const [numberError, setNumberError] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidateName(!formData.name.trim());
    setValidateCity(!formData.city.trim());
    const phoneValid =
      formData.phoneCode === 60
        ? /^\d{9,11}$/.test(formData.phone)
        : /^\d{10}$/.test(formData.phone);
    setValidateNumber(!phoneValid);
    setNumberError(formData.phone.length < 10);

    if (!formData.name.trim() || !phoneValid || !formData.city.trim()) return;

    // Submit logic here
    setBtnDisable(true);
    const response = await createLeadfromHero(formData);
    if (response?.status === 200 || response) {
      setFormData({
        name: "",
        phone: "",
        phoneCode: pageData?.contactUsPage?.phoneCode,
        city: "",
      });
      setSuccessMessage(
        "Request sent successfully. Our team will reach you soon."
      );
      alert("Request sent successfully. Our team will reach you soon.");
    }
  };

  useEffect(() => {
    const videoJsonLd = {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      name: "Wisedrive Hero Video",
      description: "A promotional video for Wisedrive.",
      thumbnailUrl: "https://wisedrive.com/thumbnail.png", // Replace with actual thumbnail URL
      uploadDate: "2025-06-10",
      contentUrl: "https://wisedrive.com/wisedrivehero.mp4", // Full video URL
      embedUrl: "https://wisedrive.com", // Full URL of the page showing the video
      publisher: {
        "@type": "Organization",
        name: "Wisedrive",
        logo: {
          "@type": "ImageObject",
          url: "https://wisedrive.com/logo192.png", // Replace with actual logo
        },
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(videoJsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section style={{ backgroundColor: "#fafbff" }}>
      <div className=" hero container">
        <div className="hero-container">
          <div className="hero-left-section">
            {/* <div className="left-btn-container"> */}
            <div className="hero-left-header">
              <div className="mbl-css">
                {pageData?.heroPage?.headLine}
                {pageData?.heroPage?.header}
              </div>
              <div
                className={
                  country == "in"
                    ? "header-subtext-container"
                    : "header-subtext-container-indo"
                }
              >
                {pageData?.heroPage?.subPoints?.map((subPoint) => {
                  return (
                    <div className="cell">
                      <DoneIcon className="iconGap" /> {subPoint}
                    </div>
                  );
                })}
              </div>
            </div>
            <ReactPlayer
              url="https://wisedrive.com/wisedrivehero.mp4"
              controls
              className="hero-video"
            />
          </div>
          <div className="hero-right-section">
            <div className="hero-cards-container">
              {pageData?.heroPage?.cardTitles?.map((card) => {
                return (
                  <div
                    className="hero-card"
                    style={{ backgroundColor: card.color }}
                  >
                    {card.content}
                  </div>
                );
              })}
            </div>
            <div className="hero-right-footer-container">
              <div className="hero-right-footer">
                <img loading="lazy" src={WarrantyImg} className="img1" alt="" />
                <img
                  loading="lazy"
                  src={GuaranteeImg}
                  className="img2"
                  alt=""
                />
                <div className="green-btn-container">
                  <a
                    aria-label=""
                    href="#inspection-plans"
                    className="hero-button-green"
                    style={{
                      display: "flex",
                      alignContent: "center",
                      alignItems: "center",
                      padding: "15px",
                    }}
                  >
                    <Button
                      sx={{
                        fontFamily: "matterMedium",
                        color: "white",
                        lineHeight: 1,
                      }}
                      className="hero-button-green"
                    >
                      {pageData?.heroPage?.btnText}
                    </Button>
                    <EastIcon fontSize="large" sx={{ color: "yellow" }} />
                  </a>
                </div>
              </div>
              {pageData?.heroPage?.rightFooterHero}
            </div>
          </div>
        </div>
      </div>
      <div className="userBannerSlicker">
        <Slider {...settings}>
          <img loading="lazy" alt="" src={suzuki} />
          <img loading="lazy" alt="" src={hyundai} />
          <img loading="lazy" alt="" src={honda} />
          <img loading="lazy" alt="" src={toyota} />
          <img loading="lazy" alt="" src={skoda} />
          <img loading="lazy" alt="" src={tata} />
          <img loading="lazy" alt="" src={ford} />
          <img loading="lazy" alt="" src={kia} />
          <img loading="lazy" alt="" src={mahindra} />
          <img loading="lazy" alt="" src={volkswagen} />
          <img loading="lazy" alt="" src={volvo} />
          <img loading="lazy" alt="" src={merc} />
          <img loading="lazy" alt="" src={audi} />
          <img loading="lazy" alt="" src={mg} />
        </Slider>
      </div>
    </section>
  );
}

export default Hero;
